jQuery(function($) {
  $(window).one('scroll', function trackScrollEvent() {
    if (window.trackCTA) trackCTA('scroll_start');
  });

  $('.side-nav-activator.left').sideNav({
    menuWidth: 250,
    edge: 'left',
    closeOnClick: true,
    draggable: false,
  });
  if (!$('html').hasClass('mobile-width')) {
    if ($(window).width() <= 767) {
      $('.nav-wrapper').addClass('mobile-width');
    }
  }
  $('.mobile-width .onlyOnMobileMenu').sideNav({
    menuWidth: 250,
    edge: 'left',
    closeOnClick: false,
    draggable: false,
    onOpen: function(el) {$('html').css({'overflow-y': 'hidden'});},
    onClose: function(el) {$('html').css({'overflow-y': 'initial'});},
  });

  $('.side-nav-activator.right').sideNav({
    menuWidth: 250,
    edge: 'right',
    closeOnClick: false,
    draggable: false,
  });
});

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;

    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

/**
 * Waits until an object or function exists under the global scope (window)
 * @param objName Name of property under window to look for the object
 * @param success Function to run when the object exists
 * @param failure Function to run on exhaustion
 * @param wait Time to wait between trials, in milliseconds (default 100)
 * @param times Number of trials to make before exhausting (default 10)
 */
function waitForObject(objName, success, failure, wait, times) {
  success = success || $.noop;
  failure = failure || $.noop;
  wait = Math.max(0, !!wait || wait === 0 ? wait : 100);
  times = !!times || times === 0 ? times : 10;

  if (window[objName]) {
    success();
  } else {
    if (times === 0) {
      failure();
    } else {
      setTimeout(function() {
        waitForObject(objName, success, failure, wait, times - 1);
      }, wait);
    }
  }
}

jQuery(document).ajaxComplete(debounce(function() {
  if (window.dataLayer) {
    dataLayer.push({
      event: 'refreshLinkClickTracking',
    });
  }
}, 750));